import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AgeGenderLuggageFaktor, AgeGenderLuggageFaktorValue } from 'src/app/models/AgeGenderLuggageFaktor.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { AgeGender } from 'src/app/models/AgeGender.model';
import { LuggageType } from 'src/app/models/luggageType.model';
import { CloneService } from 'src/app/services/clone.service';

@Component({
  selector: 'app-age-gender-luggage-factor',
  templateUrl: './age-gender-luggage-factor.component.html',
  styleUrls: ['./age-gender-luggage-factor.component.scss']
})
export class AgeGenderLuggageFactorComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder,private cloneService:CloneService) { }

  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('ageGenderLuggageFactor', this._formBuilder.array([]));
    this.form.setControl('ageGenderLuggageFactor', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('ageGenderLuggageFactor');
    this.lascCtrl= this.lascCtrl.get('values');
    this.data.values =  this.lascCtrl.value as AgeGenderLuggageFaktorValue[];
    this.gridData=this.ConvertData();
  }
  asFormGroup(o: AgeGenderLuggageFaktor): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      regionId: new FormControl(o.regionId, Validators.required),
      values: new FormControl(o.values, Validators.required)
    });
    return fg;
  }
  @Input('form') parentForm: FormGroup;
  @Input('data') data: AgeGenderLuggageFaktor;
  @Input('colHeaders') colHeaders: AgeGender[];
  @Input('rowHeaders') rowHeaders: LuggageType[];
  @Input('isEditable') isEditable: boolean;

  gridData: GridData=new GridData();
  form: FormGroup;
  lascCtrl;

  ConvertData(): GridData {
    for (let i = 0; i < this.data.values.length; i++) {
      const element = this.data.values[i];
      element.ageGenderId+=1;
      element.luggageTypeId+=1;
    }
    // for (let i = 0; i < this.data.values.length; i++)
    // {
    //   // this.data.values[i].value=parseInt((this.data.values[i].value * 100).toFixed(2));
    //   this.data.values[i].value=parseInt((this.data.values[i].value * 100).toFixed(2));
    // }
    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.rowHeaders.length; i++) {
      const headerEntry = this.rowHeaders[i];
      rowHeaders.push(new IdValue(headerEntry.id + 1,headerEntry.name));
    }

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < this.colHeaders.length; i++) {
      const headerEntry = this.colHeaders[i];
      colHeaders.push(new IdValue(headerEntry.id + 1,headerEntry.name));
    }
    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.data.values;
    grid.colProp = 'ageGenderId';
    grid.rowProp = 'luggageTypeId';
    grid.switchColWithRow = false;

    return grid;
  }

  normalizeAgeGenderAndLuggageTypeIds(temp: AgeGenderLuggageFaktorValue[]) {
    for (let i = 0; i < temp.length; i++) {
      const element = temp[i];
      element.luggageTypeId-=1;
      element.ageGenderId-=1;
      element.value=element.value;
      // element.value=element.value/100;
    }
    this.data.values=temp;
  }
  save()
  {
    let clonedGridData = this.cloneService.deepClone(this.gridData.matrix) as AgeGenderLuggageFaktorValue[];
    this.normalizeAgeGenderAndLuggageTypeIds(clonedGridData);
    if(this.lascCtrl !== null)
    {
      this.lascCtrl.patchValue(this.data.values);
    }
  }
}
